import Layout from '@/components/feature/Layout';
import ServiceDetailLayout from '@/pages/services/components/ServiceDetailLayout';
import { serviceDetails } from '@/mocks/service-details';

export default function SwimmingPoolFountainPage() {
  return (
    <Layout>
      <ServiceDetailLayout data={serviceDetails['swimming-pool-fountain']} />
    </Layout>
  );
}